import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Importiere Vuetify und Vuetify-Stile
import { createVuetify } from 'vuetify';
import 'vuetify/styles'; // Vuetify CSS-Styles
import '@mdi/font/css/materialdesignicons.css'; // Material Design Icons

// Importiere alle Vuetify-Komponenten und Direktiven
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

// Vuetify erstellen
const vuetify = createVuetify({
  components, // Alle Vuetify-Komponenten importieren
  directives, // Alle Vuetify-Direktiven importieren
  icons: {
    defaultSet: 'mdi',
  },
});

// Erstelle die App und binde Vuetify und den Router ein
createApp(App)
  .use(router)
  .use(vuetify)
  .mount('#app');
